import { Chip } from '@mui/material';

/** Table pill for a bill or statement that is a correction. */
export const CorrectionChip = () => <Chip color="info" label="Correction" />;

/** Table pill for a bill that has been corrected by another bill. */
export const HasBeenCorrectedChip = () => (
  <Chip color="secondary" label="Has Been Corrected" variant="outlined" />
);

/** Table pill for a bill that is info only. */
export const InfoOnlyChip = () => (
  <Chip color="warning" label="Info Only" variant="outlined" />
);
